import React from 'react';
import './App.css';
import Login from './Components/Login/Login';
import CreateRef from './Components/CreateReference/CreateRef';
import SearchRef from './Components/SearchReference/SearchRef';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ViewRefDetails from './Components/ViewReference/ViewRefDetails';
import GoogleMapView from './Components/MapView/mapGoogleView';
import HomeView from './Components/HomeView/home';
// import history from './Components/Routes/history';
import PrivateRoute from './Components/Routes/privateRoutes';
import ShowRef from './Components/ViewReference/ShowRef';
import EditReference from './Components/EditReference/editRef';


class App extends React.Component {

  render() {
    return (
      <BrowserRouter  >
        <div className="App">
          <Routes>
            <Route exact path="/" Component={Login} />
            <Route exact path="/login" Component={Login} />
            <Route element={<PrivateRoute/>}>
              <Route exact path='/home' Component={HomeView}/>
              <Route path="/createRef" Component={CreateRef} />
              <Route path="/searchRef" Component={SearchRef} />
              <Route path="/viewRef" Component={ShowRef} />
              <Route path="/viewRefDetails/:id" Component={ViewRefDetails} />
              <Route path="/editRef" Component={EditReference} />
              <Route path="/viewMap" Component={GoogleMapView} />
            </Route>
          </Routes>
        </div>
      </BrowserRouter>
    )
  }
}


export default App;

